const formatePoints = (v, digits = 0, minDigits) => {
  const digitalValue = Number(v);
  if (isNaN(digitalValue)) return v;

  const formatted = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: minDigits ?? digits,
    maximumFractionDigits: digits,
  }).format(digitalValue);

  return formatted.replace(',', '.');;
}

export {
  formatePoints,
}